import React, { useState, useEffect, useRef } from "react";
import "styles/scss/login.scss";
import { useNavigate } from "react-router-dom";
import { getLocalItem, setLocalItem, setSessionItem } from 'utils/storage';
import * as EgovNet from 'api/fetch';

function Login() {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState({
        userId: "",
        userPswd: "default"
    });
    const [saveIDFlag, setSaveIDFlag] = useState(false);    
    const checkRef = useRef();
    const idRef=useRef(null);//id입력 부분에서 엔터키 이벤트 발생 확인
    const passwordRef=useRef(null);//비밀번호 입력 부분

    const KEY_ID = "KEY_ID";
    const KEY_SAVE_ID_FLAG = "KEY_SAVE_ID_FLAG";
    const KEY_NM = "KEY_NM";

    const handleSaveIDFlag = () => {
        setLocalItem(KEY_SAVE_ID_FLAG, !saveIDFlag)
        setSaveIDFlag(!saveIDFlag);
    };

    useEffect(() => {
        let idFlag = getLocalItem(KEY_SAVE_ID_FLAG);
        if (idFlag === null) {
            setSaveIDFlag(false);
			// eslint-disable-next-line react-hooks/exhaustive-deps
            idFlag = false;
        } else {
            setSaveIDFlag(idFlag);
        }
        if (idFlag === false) {
            setLocalItem(KEY_ID, "");
            setLocalItem(KEY_NM, "");
            checkRef.current.className = "f_chk"
        } else {
            checkRef.current.className = "f_chk on"
        };
    }, []);
      
    useEffect(() => {
        let data = getLocalItem(KEY_ID);
        if (data !== null) {
            setUserInfo({ userId: data, userPswd: 'default'});
        }
    }, []);

    const activeEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (e.target === idRef.current && passwordRef.current.value === "") {
                //엔터 키 이벤트 발생한 입력 필드가 아이디인지 확인하기
                alert("비밀번호 입력 여부를 확인하여 주세요");
                passwordRef.current.focus();
            } else {
                submitFormHandler(e);
            }
        }
    };

    // 로그인 버튼 클릭 시
    const submitFormHandler = () => {
        const loginUrl = "/api/login";
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(userInfo)
        };
        EgovNet.requestFetch(loginUrl, requestOptions, (resp) => {
            let resultVO = resp.resultVO;
            if (resp.resultCode === 200) {
                setSessionItem("loginUser", resultVO);
                if (saveIDFlag)
                setLocalItem(KEY_ID, resultVO?.id);
                setLocalItem(KEY_NM, resultVO?.name);
                navigate('/psts');
            } else {
                alert('로그인이 되지 않았습니다.');
            }
        });
    };

    return (
        <div className="login-container">
            <form className="login-box">
                <div className="logo"></div>
                <ul>
                    <li className="li-flex">
                        <span className="id-icon">아이디</span>
                        <label htmlFor="id" className="visually-hidden">아이디</label>
                        <input
                            type="text"
                            id="id"
                            className="form-control login-form"
                            value={userInfo?.id}
                            placeholder="아이디를 입력해주세요"
                            onChange={(e) => setUserInfo({ ...userInfo, userId: e.target.value })}
                            ref={idRef}
                            onKeyDown={activeEnter}
                        />
                    </li>
                    <li className="li-flex">
                        <span className="password-icon">비밀번호</span>
                        <label htmlFor="password" className="visually-hidden">비밀번호</label>
                        <input
                            type="password"
                            id="password"
                            className="form-control login-form"
                            placeholder="비밀번호를 입력해주세요"
                            onChange={(e) => setUserInfo({ ...userInfo, userPswd: e.target.value })}
                            ref={passwordRef}
                            onKeyDown={activeEnter}
                        />
                    </li>
                    <li className="li-flex02">
                        <input type="checkbox"
                            id="saveid"
                            onChange={handleSaveIDFlag}
                            checked={saveIDFlag}
                        />
                        <label className="visually-hidden f_chk" htmlFor="saveid" ref={checkRef}>아이디 저장</label>
                    </li>
                    <li>
                        <button type="submit" className="btn login-btn" onClick={submitFormHandler}>로그인</button>
                    </li>
                </ul>
                <div className="bg"></div>
            </form>
        </div>
    );
}

export default Login;
